import { defineMessages } from 'react-intl';

export const streamingChildRunPanelMessages = defineMessages({
  noOutput: {
    defaultMessage: 'No output from this run.',
    id: 'xwoHIqp/ki',
    description: 'Empty state in an expanded streaming child-run panel',
  },
  approvalWaiting: {
    defaultMessage: 'This run is waiting for approval. Open it to resolve.',
    id: 'z2j6+5sL4w',
    description: 'Notice when a child run is blocked on human approval',
  },
});
